import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';

@Component({
  selector: 'app-new-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.sass']
})
export class NewFooterComponent extends BaseNewComponents implements OnInit {

  seals = [
    {
      id: 1,
      img: 'assets/img/view/gptw-seal.png',
      alt: 'Great Place to Work',
      class: 'footer__items-seal__gptw'
    },
    {
      id: 2,
      img: 'assets/img/view/ra-certificate.png',
      alt: 'RA Certificate',
      class: 'footer__items-seal__ra-certificate'
    }
  ];

  apps = [
    {
      id: 1,
      href: 'https://apps.apple.com/br/app/clube-montreal/id1513435651',
      icon: 'apple'
    },
    {
      id: 2,
      href: 'https://play.google.com/store/apps/details?id=br.com.clube.montreal.institucional',
      icon: 'google'
    }
  ];

  socials = [
    {
      id: 1,
      title: 'Facebook Montreal - Clube de Hospedagem',
      href: 'https://www.facebook.com/ClubeMontreal/',
      icon: 'facebook'
    },
    {
      id: 2,
      title: 'Instagram Montreal - Clube de Hospedagem',
      href: 'https://www.instagram.com/clubemontreal/',
      icon: 'instagram'
    },
    {
      id: 3,
      title: 'Youtube Montreal - Clube de Hospedagem',
      href: 'https://www.youtube.com/user/clubemontreal',
      icon: 'youtube'
    },
    {
      id: 4,
      title: 'LinkedIn Montreal - Clube de Hospedagem',
      href: 'https://pt.linkedin.com/company/montreal-clube-de-hospedagem',
      icon: 'linkedin'
    },
  ];
  public socialSizeWidth: string;
  public socialSizeHeight: string;
  public logoSizeWidth: string;
  public logoSizeHeight: string;
  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.socialSizeMobile();
  }
  socialSizeMobile() {
    if (this.currentGridSize > 0 && this.currentGridSize <= 280) {
      this.socialSizeWidth = '26px';
      this.socialSizeHeight = '28px';
      this.logoSizeWidth = '180px';
      this.logoSizeHeight = '100px';
    } else if (this.currentGridSize > 280 && this.currentGridSize <= 320) {
      this.socialSizeWidth = '26px';
      this.socialSizeHeight = '28px';
      this.logoSizeWidth = '180px';
      this.logoSizeHeight = '100px';
    } else if (this.currentGridSize > 320 && this.currentGridSize <= 360) {
      this.socialSizeWidth = '26px';
      this.socialSizeHeight = '28px';
      this.logoSizeWidth = '180px';
      this.logoSizeHeight = '100px';
    } else if (this.currentGridSize > 360 && this.currentGridSize <= 411) {
      this.socialSizeWidth = '36px';
      this.socialSizeHeight = '38px';
      this.logoSizeWidth = '180px';
      this.logoSizeHeight = '100px';
    } else {
      this.socialSizeWidth = '36px';
      this.socialSizeHeight = '38px';
      this.logoSizeWidth = '250px';
      this.logoSizeHeight = '150px';
    }
  }
}
